import { FileBasic } from '@commenda/types/src/file/types';
import { fetcher } from '@commenda/utils';
import { TaskParty, TaskStatus } from '@prisma/client';
import { API_BASE_PATH } from './constants';

export async function updateTask({
  id,
  data,
}: {
  id: number;
  data: {
    status?: TaskStatus;
    metadata?: Record<string, any>;
    files?: FileBasic[];
    legacyServiceRequestTaskOrderNumber?: number;
    pendingOn?: TaskParty;
    isIssueReported?: boolean;
  };
}) {
  try {
    const res = await fetcher(
      `${API_BASE_PATH}/task/${id}`,
      {
        method: 'POST',
        body: data,
      },
      undefined
    );

    return res;
  } catch (err) {
    console.error(err);
    return err;
  }
}
